<template>
    <div v-if="!loading">
        <h3 class="text-primary mb-2 mt-50">مدیریت اشتراک</h3>
        <b-card>
            <b-row>
                <b-col v-for="(item, index) in subscriptionInfo" :key="`info-${index}`" md="3" cols="6"
                    :class="{ 'mb-2 mb-md-0': index == 0 || index == 1 }">
                    <div class="d-flex justify-content-center align-items-center">
                        <b-media no-body>
                            <b-media-aside>
                                <b-avatar size="50" :variant="item.color">
                                    <feather-icon size="24" :icon="item.icon" />
                                </b-avatar>
                            </b-media-aside>
                            <b-media-body class="my-auto">
                                <h4 class="mb-25">
                                    {{ item.title }}
                                </h4>
                                <b-card-text class="text-muted mb-0">
                                    {{ item.subtitle }}
                                </b-card-text>
                            </b-media-body>
                        </b-media>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <div class="d-flex justify-content-center my-3">
            <b-button @click="showModalSubscriptionRenewal" variant="primary" class="px-md-5 px-2 py-1">
                تمدید اشتراک
            </b-button>
            <b-button v-if="currentSubscriptionId != 3" @click="$bvModal.show('subscription-upgrade')" variant="primary"
                class="px-md-5 px-2 py-1 ml-2">
                ارتقاء اشتراک
            </b-button>
        </div>
        <div>
            <div>
                <div class="h-100">

                    <div class="responsive-desktop">
                        <div class="pb-5">
                            <b-card no-body class="subscriptions-nav position-sticky py-2">
                                <h4 class="mb-0 text-center">مقایسه و جزئیات اشتراک ها</h4>
                                <h4 v-for="(subscription, subscriptionIndex) in subscriptions"
                                    :key="`subscription-${subscriptionIndex}`" class="text-center mb-0">
                                    {{ subscription.title }}
                                </h4>
                            </b-card>
                            <div v-for="(featureGroup, featureGroupIndex) in featureGroups"
                                :key="`group-${featureGroupIndex}`">
                                <h4 class="mt-3 font-weight-bolder px-1">
                                    {{ featureGroup.title }}
                                </h4>
                                <div v-for="(feature, featureIndex) in featureGroup.features"
                                    class="feature-item align-items-center prevent-select py-1 px-1"
                                    :key="`feature-${featureGroupIndex}-${featureIndex}`"
                                    :class="{ 'border-top': featureIndex != 0 }">
                                    <div>{{ feature }}</div>
                                    <div v-for="(subscription, subscriptionIndex) in subscriptions"
                                        :key="`check-${subscriptionIndex}`" class="text-center pt-25 ml-1">
                                        <span v-if="hasFeature(subscription, featureGroupIndex, featureIndex)">✔️</span>
                                        <span v-else>❌</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="responsive-mobile">
                        <div class="pb-5">
                            <h4 class="mb-2 text-center">مقایسه و جزئیات اشتراک ها</h4>
                            <b-card no-body class="position-sticky px-2 py-50" style="top: 90px;">
                                <b-row>
                                    <b-col v-for="(subscription, subscriptionIndex) in subscriptions" cols="4"
                                        :key="`mobile-subscription-${subscriptionIndex}`"
                                        @click="subscriptionActive = subscriptionIndex"
                                        :class="{ 'bg-secondary text-white': subscriptionActive == subscriptionIndex }"
                                        class="text-center rounded py-75">
                                        <span class="mb-0">{{ subscription.title }}</span>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <div v-for="(featureGroup, featureGroupIndex) in featureGroups"
                                :key="`mobile-group-${featureGroupIndex}`">
                                <h4 class="px-50 mt-3">
                                    {{ featureGroup.title }}
                                </h4>
                                <div v-for="(feature, featureIndex) in featureGroup.features"
                                    class="d-flex align-items-center justify-content-between prevent-select py-2 px-50"
                                    :key="`mobile-feature-${featureGroupIndex}-${featureIndex}`"
                                    :class="{ 'border-top': featureIndex != 0 }">
                                    <div class="mr-3">{{ feature }}</div>
                                    <div v-for="(subscription, subscriptionIndex) in subscriptions"
                                        :key="`mobile-check-${subscriptionIndex}`"
                                        v-if="subscriptionActive == subscriptionIndex">
                                        <span v-if="hasFeature(subscription, featureGroupIndex, featureIndex)">✔️</span>
                                        <span v-else>❌</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-------------------------------------- subscription renewal -------------------------------------->
        <b-modal id="subscription-renewal" title="تمدید اشتراک" centered :hide-footer="true" size="sm"
            title-class="font-weight-bolder">
            <div class="py-1">
                <div class="px-1 mb-2 pb-1">
                    <h6 class="text-center">مدت زمان اشتراک خود را انتخاب کنید</h6>
                    <b-row class="border-primary p-50 rounded">
                        <b-col v-for="(item, index) in subscriptionsDurations" :key="`duration${index}`" cols="4"
                            @click="durationActive = index" :class="{ 'bg-info text-white': durationActive == index }"
                            class="py-75 pointer rounded">
                            <div class="text-center"> {{ item.title }}</div>
                        </b-col>
                    </b-row>
                </div>
                <div class="px-1 mb-2">
                    <h6 class="text-center">در صورت نیاز، نوع اشتراک فعلی خود را تغییر دهید</h6>
                    <b-row class="border-primary p-50 rounded">
                        <b-col v-for="(item, index) in subscriptions" :key="`subscription${index}`" cols="4"
                            @click="form.subscriptionId = item.id"
                            :class="{ 'bg-info text-white': form.subscriptionId == item.id }"
                            class="py-75 pointer rounded">
                            <div class="text-center">
                                {{ item.title }}
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-for="(subscription, index) in subscriptions" :key="`subscription-${index}`">
                    <div v-if="form.subscriptionId == subscription.id" class="text-center">
                        <div class="d-flex align-items-center justify-content-center my-2 pt-50">
                            <h4 class="mb-0 mr-25">
                                {{ (subscription.durations[durationActive].price / 10).toLocaleString('fa-IR') }}
                            </h4>
                            <span>تومان</span>
                        </div>
                    </div>
                </div>
                <b-button @click="subscriptionRenewal" :disabled="loadingButton" variant="primary"
                    class="d-flex align-items-center justify-content-center py-1 w-100">
                    <span>پرداخت</span>
                    <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                </b-button>
            </div>
        </b-modal>

        <!-------------------------------------- subscription upgrade -------------------------------------->
        <b-modal id="subscription-upgrade" title="ارتقاء اشتراک" centered :hide-footer="true" size="sm"
            title-class="font-weight-bolder">
            <div class="py-1">
                <div class="px-1 mb-2">
                    <p class="text-center pb-1">
                        در حال حاضر اشتراک حساب شما "{{ subscriptionInfo[0].title }}" میباشد. برای ارتقاء اشتراک،
                        اشتراک مورد نظر را انتخاب و با پرداخت مابه التفاوت، اشتراک شما ارتقاء می یابد.
                    </p>
                    <b-row class="border-primary p-50 rounded mt-2">
                        <b-col v-for="(item, index) in subscriptions" :key="`subscription${index}`" cols="4"
                            @click="form.subscriptionId = item.id"
                            :class="{ 'bg-info text-white': form.subscriptionId == item.id }"
                            class="py-75 pointer rounded">
                            <div class="text-center">
                                {{ item.title }}
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <b-button @click="subscriptionUpgradeDetails" variant="primary"
                    class="d-flex align-items-center justify-content-center py-1 w-100"
                    :disabled="form.subscriptionId <= currentSubscriptionId || loadingButton">
                    <span>نمایش صورتحساب</span>
                    <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                </b-button>
            </div>
        </b-modal>

        <!-------------------------------------- subscription upgrade details -------------------------------------->
        <b-modal id="subscription-upgrade-details" title="صورتحساب" centered :hide-footer="true" size="sm"
            title-class="font-weight-bolder">
            <div class="py-1">
                <div class="px-1 mb-2">
                    <p class="text-center pb-1">مبلغ اشتراک فعلی و اشتراک انتخاب شده، بر اساس روز های باقی مانده محاسبه
                        شده
                        است.</p>
                    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between mt-2">
                        <h6>روز های باقی مانده</h6>
                        <span class="line-between-two-elements mx-75 mb-25"></span>
                        <h6>
                            {{ subscriptionUpgradeDetailsData.remainDays }}
                            <span>روز</span>
                        </h6>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between mt-1">
                        <h6>اشتراک انتخاب شده ({{ subscriptionUpgradeDetailsData.newSubscriptionTitle }})</h6>
                        <span class="line-between-two-elements mx-75 mb-25"></span>
                        <h6>
                            {{ (Math.round(subscriptionUpgradeDetailsData.newSubscriptionPriceForRemainDays /
                                10).toLocaleString('fa-IR')) }}
                            <span>تومان</span>
                        </h6>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between mt-1">
                        <h6>اشتراک فعلی ({{ subscriptionUpgradeDetailsData.oldSubscriptionTitle }})</h6>
                        <span class="line-between-two-elements mx-75 mb-25"></span>
                        <h6>
                            {{ (Math.round(subscriptionUpgradeDetailsData.oldSubscriptionPriceForRemainDays /
                                10).toLocaleString('fa-IR')) }}
                            <span>تومان</span>
                        </h6>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between mt-1">
                        <h6>مبلغ قابل پرداخت</h6>
                        <span class="line-between-two-elements mx-75 mb-25"></span>
                        <h6>
                            {{ (Math.round(subscriptionUpgradeDetailsData.totalPayablePrice /
                                10).toLocaleString('fa-IR')) }}
                            <span>تومان</span>
                        </h6>
                    </div>
                </div>
                <b-button @click="subscriptionUpgrade" variant="primary"
                    class="d-flex align-items-center justify-content-center py-1 w-100"
                    :disabled="form.subscriptionId <= currentSubscriptionId || loadingButton">
                    <span>پرداخت</span>
                    <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                </b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { BButton, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BCard, BFormInput, BFormRadio, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';

export default {
    components: {
        BButton,
        BCardText,
        BCardBody,
        BRow,
        BCol,
        BMedia,
        BMediaAside,
        BAvatar,
        BMediaBody,
        BCard,
        BFormInput,
        BFormRadio,
        BSpinner
    },
    data() {
        return {
            subscriptions: [],
            featureGroups: [],
            storeId: null,
            loading: true,
            loadingButton: false,
            durationActive: 1,
            subscriptionActive: 0,
            form: {
                totalDays: null,
                subscriptionId: null,
            },
            currentSubscriptionId: null,
            subscriptionsDurations: [
                { index: 0, title: 'سه ماهه', },
                { index: 1, title: 'شش ماهه', },
                { index: 2, title: 'یک ساله', },
            ],
            subscriptionUpgradeDetailsData: {
                oldSubscriptionPriceForRemainDays: 0,
                newSubscriptionPriceForRemainDays: 0,
                totalPayablePrice: 0,
            },
            subscriptionInfo: [
                {
                    icon: 'CpuIcon',
                    color: 'light-primary',
                    subtitle: 'نام اشتراک',
                    title: '',
                },
                {
                    icon: 'ClockIcon',
                    color: 'light-warning',
                    subtitle: 'باقی مانده',
                    title: '',
                }, {
                    icon: 'ClockIcon',
                    color: 'light-secondary',
                    subtitle: 'کل روز ها',
                    title: '',
                }, {
                    icon: 'ActivityIcon',
                    color: 'light-info',
                    subtitle: 'رزرو',
                    title: '',
                },
            ],
        }
    },
    methods: {
        showModalSubscriptionRenewal() {
            this.form.subscriptionId = this.currentSubscriptionId
            this.$bvModal.show('subscription-renewal')
        },
        getGlobalFeatureIndex(featureGroupIndex, featureIndex) {
            let index = 0;
            for (let i = 0; i < featureGroupIndex; i++) {
                index += this.featureGroups[i].features.length;
            }
            return index + featureIndex;
        },
        hasFeature(subscription, featureGroupIndex, featureIndex) {
            const globalIndex = this.getGlobalFeatureIndex(featureGroupIndex, featureIndex);
            return subscription.features[globalIndex];
        },
        async getSubscriptions() {
            await this.$axios.get('/Subscription').then(({ data }) => {
                this.subscriptions = data.subscriptions
                this.featureGroups = data.featureGroups
                this.loading = false
            })
                .catch(() => { });
        },
        getSubscriptionInfo() {
            storeService.getSubscriptionInfo(this.storeId).then(({ data }) => {
                this.subscriptionInfo[0].title = data.current.subscription.title
                this.subscriptionInfo[1].title = `${data.current.remainDays} روز`
                this.subscriptionInfo[2].title = `${data.current.totalDays} روز`
                this.subscriptionInfo[3].title = `${data.hasReservedSubscription ? 'فعال' : 'غیرفعال'}`
                this.form.subscriptionId = data.current.subscription.id
                this.currentSubscriptionId = data.current.subscription.id
                this.getSubscriptions()
            })
        },
        subscriptionRenewal() {
            this.loadingButton = true;
            this.form.totalDays = this.subscriptions[this.form.subscriptionId - 1].durations[this.durationActive].totalDays
            storeService.subscriptionRenewal(this.storeId, this.form).then(({ data }) => {
                localStorage.setItem("gatewayData", JSON.stringify(data));
                this.$router.push(`/redirect-to-gateway`)
            })
                .catch(() => {
                    this.loadingButton = false
                });
        },
        subscriptionUpgradeDetails() {
            this.loadingButton = true
            storeService.subscriptionUpgradeDetails(this.storeId, this.form.subscriptionId).then(({ data }) => {
                this.subscriptionUpgradeDetailsData = data
                this.$bvModal.hide('subscription-upgrade');
                this.$bvModal.show('subscription-upgrade-details')
                this.loadingButton = false
            })
                .catch(() => {
                    this.loadingButton = false
                });
        },
        subscriptionUpgrade() {
            this.loadingButton = true
            storeService.subscriptionUpgrade(this.storeId, { subscriptionId: this.form.subscriptionId }).then(({ data }) => {
                localStorage.setItem("gatewayData", JSON.stringify(data));
                this.$router.push(`/redirect-to-gateway`)
            })
                .catch(() => {
                    this.loadingButton = false
                    this.$bvModal.hide('subscription-upgrade-details')
                });
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getSubscriptionInfo()
    },
};
</script>

<style lang="scss">
.subscriptions {
    &-nav {
        display: grid;
        grid-template-columns: 9fr repeat(3, 3fr);
        top: 100px;
    }
}

.feature-item {
    display: grid;
    grid-template-columns: 9fr repeat(3, 3fr);

    &:hover {
        background-color: #ffffff16;
    }
}
</style>